module.exports = __webpack_public_path__ + "img/pic_zb_d6.baf1ef72.png";